// extracted by mini-css-extract-plugin
export var body = "_hm-0";
export var sectionHeader = "_hm-4";
export var shortcutColumns = "_hm-2";
export var shortcutList = "_hm-1";
export var shortcutSection = "_hm-3";